import http from "./httpService";
import { getConfig } from "../config/config.js";

const config = getConfig();
const serviceEndpoint = config.apiEndpoint + "/public/torneos";

// Lectura pública (sin login) de torneos para la app de jugadores.
// Mismo shape de respuesta que torneosService, pero contra /api/public.

export async function getTorneosPublic() {
  try {
    const response = await http.get(serviceEndpoint);
    return response.data.records;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return error.message.toUpperCase();
    else return [];
  }
}

export async function getTorneoPublic(recordId) {
  try {
    const response = await http.get(serviceEndpoint + "/" + recordId);
    return response.data.record;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return error.message.toUpperCase();
    else return [];
  }
}

// Última modificación del torneo (unas decenas de bytes). La pantalla pública la
// consulta cada tanto y recién baja el torneo entero si cambió.
// Devuelve null ante cualquier problema: un chequeo fallido saltea el ciclo, no rompe.
export async function getVersionTorneoPublic(recordId) {
  try {
    const response = await http.get(serviceEndpoint + "/" + recordId + "/version");
    return response.data.updated || null;
  } catch (error) {
    return null;
  }
}
